import { APPLICANT_STAGE } from '../../RentalPortalApplicant'

export const QA_NAME_APPLICANT_PROFILE_PAGE = 'rentalPortalApplicant'

export const QA_NAME_APPLICANT_PROFILE_LOAD_RETRY = 'applicantProfileRetry'

export const APPLICANT_PROFILE_ARCHIVE_BLOCKED_STAGES = [
  APPLICANT_STAGE.selected,
  APPLICANT_STAGE.approved,
]

export const APPLICANT_ATTENTION_ACTION_KEY = {
  approve: 'approve',
  moveToScreening: 'move_to_screening',
  recordVerdict: 'record_verdict',
}

export const APPLICANT_TERMINAL_STAGES = [
  APPLICANT_STAGE.rejected,
  APPLICANT_STAGE.withdrawn,
]

export const QA_NAME_APPLICANT_PROFILE_PREVIEW_OPEN_PROFILE =
  'applicantPreviewOpenProfile'

export const QA_NAME_APPLICANT_PROFILE_PREVIEW_OPEN_FULL_PAGE =
  'applicantPreviewOpenFullPage'
